export default "__VITE_PUBLIC_ASSET__c932cb92__"